import { useQuery } from "@tanstack/react-query";
import { workQueueService } from "@/core/api/services";
import { workbenchKeys } from "@/core/api/queryKeys";

export function useWorkItem(id: string | undefined) {
  const query = useQuery({
    queryKey: workbenchKeys.workItems.detail(id ?? ""),
    queryFn: async () => {
      const response = await workQueueService.getWorkItem({ id });
      return response.item ?? null;
    },
    enabled: !!id,
    staleTime: 10 * 1000,
  });

  return {
    item: query.data ?? null,
    loading: query.isLoading,
    error: query.error?.message ?? null,
    refetch: query.refetch,
  };
}
